import { useSelector } from "react-redux"
import { RootState } from "../store"
import { TUser } from "../shared/types/user.type"
import { useMemo } from "react"
import { metrics } from "../enums/register.enums"
import { useTranslation } from "react-i18next"
import { Chukker } from "../shared/types/chukkers.type"

export const useChukkerTranslation = () => {
    const { t } = useTranslation()


    const userMetric = useSelector<RootState>(state => state.user.user?.unit_system) as TUser['unit_system']
    const keys = useMemo(() => [
        //duracion del trabajo
        {
            key: "work_duration",
            value: t('eap:table:headers:chukkerXxWorkDuration'),
            enabled: true
        },
        //⁠distancia de trabajo
        {
            key: "work_distance",
            value: t('eap:table:headers:chukkerXxWorkDistance'),
            enabled: true
        },
        //velocidad maxima
        {
            key: "work_max_speed",
            value: t('eap:table:headers:chukkerXxWorkMaxSpeed'),
            enabled: true
        },
        //frecuencia cardiaca maxima
        {
            key: "work_max_hr",
            value: t('eap:table:headers:chukkerXxWorkMaxHr'),
            enabled: true
        },
        //frecuencia cardiaca después de 1 min
        {
            key: "bpm_after_60_s",
            value: t('eap:table:headers:chukkerXxBpmAfterYyS', {
                0: "1", interpolation: {
                    escapeValue: false
                }
            }),
            enabled: true
        },
        //⁠frecuencia cardiaca después de 3 min
        {
            key: "bpm_after_180_s",
            value: t('eap:table:headers:chukkerXxBpmAfterYyS', {
                0: '3 ', interpolation: {
                    escapeValue: false
                }
            }),
            enabled: true
        },
        //⁠tiempo en llegar a 100 lpm
        {
            key: "time_to_100_bpm",
            value: t('eap:table:headers:chukkerXxTimeToYyBpm', {
                0: "100 ", interpolation: {
                    escapeValue: false
                }
            }),
            enabled: true
        },
        //tiempo en zona de trabajo intenso 174-196 lpm
        {
            key: "work_time_high_hr",
            value: t('eap:table:headers:timeVeryIntenseWorkZonePolo'),
            enabled: true
        },
        //⁠tiempo en zona de trabajo muy intenso >196 lpm
        {
            key: "work_time_very_high_hr",
            value: t('eap:table:headers:timeIntenseWorkZonePolo'),
            enabled: true
        },
        //⁠longitud maxima de zancada
        {
            key: "max_stride_length",
            value: t('eap:table:headers:maxStrideLength'),
            enabled: true
            //frecuencia de zancada a maxima velocidad
        }, {
            key: "stride_frequency_at_vmax",
            value: t('eap:table:headers:strideFrequencyAtVmax'),
            enabled: true
        },

        //mejor aceleracion
        {
            key: "best_acceleration",
            value: t('eap:table:headers:chukkerXxBestAcceleration'),
            enabled: true
        },
        //cantidad de aceleraciones
        {
            key: "number_acceleration",
            value: t('eap:table:headers:chukkerNumberAcceleration'),
            enabled: true,
        },
        //mejor frenada
        {
            key: "best_braking",
            value: t('eap:table:headers:chukkerXxBestBraking'),
            enabled: true
        },
        //cantidad de frenadas
        {
            key: "number_braking",
            value: t('eap:table:headers:chukkerNumberBraking'),
            enabled: true,
        },
        //V200
        {
            key: "v200",
            value: t('eap:table:headers:v200'),
            enabled: true,
        },
        //mejor sprint
        {
            key: "best_sprint",
            value: t('eap:table:headers:chukkerXxBestSprint'),
            enabled: true
        },
        //cantidad de sprints
        {
            key: "number_sprint",
            value: t('eap:table:headers:chukkerXxNbrSprint'),
            enabled: true
        },

        //DISABLED 
        {
            key: "work_distance_30",
            value: t('eap:table:headers:chukkerXxWorkDistance30', {
                0: userMetric === 'imperial' ? '18.6' : '30',
                1: userMetric === 'imperial' ? 'mph' : "km/h",
                interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "work_mean_stride_length",
            value: t('eap:table:headers:chukkerXxWorkMeanStrideLength'),
            enabled: false
        },
        {
            key: "bpm_after_180_s_percent",
            value: t('eap:table:headers:chukkerXxBpmAfterYySPercent', {
                0: '% ',
                1: '3 ',
                interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "hr_reserve",
            value: t('eap:table:headers:chukkerXxHrReserve'),
            enabled: false
        },
        {
            key: "avrg_acceleration",
            value: t('eap:table:headers:chukkerXxAvrgAcceleration'),
            enabled: false
        },
        {
            key: "avrg_braking",
            value: t('eap:table:headers:chukkerXxAvrgBraking'),
            enabled: false
        },
        {
            key: "bpm_after_60_s_Percent",
            value: t('eap:table:headers:chukkerXxBpmAfterYySPercent', {
                0: "%",
                1: "60",
                interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "recov_max_hr",
            value: t('eap:table:headers:chukkerXxRecovMaxHr'),
            enabled: false
        },
        {
            key: "recov_mean_hr",
            value: t('eap:table:headers:chukkerXxRecovMeanHr'),
            enabled: false
        },
        {
            key: "recov_mean_speed",
            value: t('eap:table:headers:chukkerXxRecovMeanSpeed'),
            enabled: false
        },
        {
            key: "recov_min_hr",
            value: t('eap:table:headers:chukkerXxRecovMinHr'),
            enabled: false
        },
        {
            key: "recovery_duration",
            value: t('eap:table:headers:chukkerXxRecovDuration'),
            enabled: false
        },
        {
            key: "work_mean_hr",
            value: t('eap:table:headers:chukkerXxWorkMeanHr'),
            enabled: false
        }, {
            key: "work_mean_speed",
            value: t('eap:table:headers:chukkerXxWorkMeanSpeed'),
            enabled: false
        }, {
            key: "work_mean_stride_frequency",
            value: t('eap:table:headers:chukkerXxWorkMeanStrideFrequency'),
            enabled: false
        }, {
            key: "work_min_hr",
            value: t('eap:table:headers:chukkerXxWorkMinHr'),
            enabled: false
        },
        {
            key: "time_to_64_bpm",
            value: t('eap:table:headers:chukkerXxTimeToYyBpm', {
                0: "64 ", interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "time_to_70_bpm",
            value: t('eap:table:headers:chukkerXxTimeToYyBpm', {
                0: "70 ", interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "time_to_75_bpm",
            value: t('eap:table:headers:chukkerXxTimeToYyBpm', {
                0: "75 ", interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "time_to_80_bpm",
            value: t('eap:table:headers:chukkerXxTimeToYyBpm', {
                0: "80 ", interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "time_to_85_bpm",
            value: t('eap:table:headers:chukkerXxTimeToYyBpm', {
                0: "85 ", interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "time_to_90_bpm",
            value: t('eap:table:headers:chukkerXxTimeToYyBpm', {
                0: "90 ", interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "time_to_95_bpm",
            value: t('eap:table:headers:chukkerXxTimeToYyBpm', {
                0: "95 ", interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "work_distance_low_speed",
            value: t('eap:table:headers:chukkerXxWorkDistanceLowSpeed'),
            enabled: false
        },
        {
            key: "work_distance_moderate_speed",
            value: t('eap:table:headers:chukkerXxWorkDistanceModerateSpeed'),
            enabled: false
        },
        {
            key: "work_distance_high_speed",
            value: t('eap:table:headers:chukkerXxWorkDistanceHighSpeed'),
            enabled: false
        },
        {
            key: "work_distance_very_high_speed",
            value: t('eap:table:headers:chukkerXxWorkDistanceVeryHighSpeed'),
            enabled: false
        },
        {
            key: "work_min_speed",
            value: t('eap:table:headers:chukkerXxWorkMinSpeed'),
            enabled: false
        },
        {
            key: "bpm_after_120_s",
            value: t('eap:table:headers:chukkerXxBpmAfterYyS', {
                0: '2 ', interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "bpm_after_240_s",
            value: t('eap:table:headers:chukkerXxBpmAfterYyS', {
                0: '4 ', interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "bpm_after_300_s",
            value: t('eap:table:headers:chukkerXxBpmAfterYyS', {
                0: '5 ', interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "bpm_after_300_s_percent",
            value: t('eap:table:headers:chukkerXxBpmAfterYySPercent', {
                0: '% ',
                1: '5 ', interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "bpm_after_240_s_percent",
            value: t('eap:table:headers:chukkerXxBpmAfterYySPercent', {
                0: '% ',
                1: '4 ',
                interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },
        {
            key: "bpm_after_120_s_percent",
            value: t('eap:table:headers:chukkerXxBpmAfterYySPercent', {
                0: '% ',
                1: '2 ',
                interpolation: {
                    escapeValue: false
                }
            }),
            enabled: false
        },


    ], [userMetric, t])


    const enabledKeys = keys.filter(key => key.enabled).map(e => e.key) as (keyof Chukker)[]

    console.log({ enabledKeys });

    const getTranslationByKey = (key: string) => {

        const foundKey = keys.find(k => k.key === key)
        if (foundKey) {
            return foundKey.value
        } else {
            console.log("Key not found for translation : " + key)
            return key
        }

    }


    return {
        getTranslationByKey,
        enabledKeys
    }
}